'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = require('react-router-redux');

var _combineReducers = require('./combineReducers');

var _combineReducers2 = _interopRequireDefault(_combineReducers);

var _Agents = require('./Agents');

var _Builder = require('./Builder');

var _Settings = require('./Settings');

var _Homes = require('./Homes');

var _Lots = require('./Lots');

var _Plans = require('./Plans');

var _Events = require('./Events');

var _Communities = require('./Communities');

var _Filters = require('./Filters');

var _Blogposts = require('./Blogposts');

var _Map = require('./Map');

var _ServerSide = require('./ServerSide');

var _Favorites = require('./Favorites');

var _HoaPortal = require('./HoaPortal');

var _User = require('./User');

var _Compare = require('./Compare');

var _UTMCodes = require('./UTMCodes');

var _scrollReducer = require('./scrollReducer');

var _scrollReducer2 = _interopRequireDefault(_scrollReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appReducer = (0, _combineReducers2.default)({
  cloudData: (0, _combineReducers2.default)({
    agents: _Agents.reducer,
    blogposts: _Blogposts.reducer,
    builder: _Builder.reducer,
    communities: _Communities.reducer,
    homes: _Homes.reducer,
    lots: _Lots.reducer,
    plans: _Plans.reducer,
    settings: _Settings.reducer,
    events: _Events.reducer
  }),
  compare: _Compare.reducer,
  favorites: _Favorites.reducer,
  hoaPortal: _HoaPortal.reducer,
  user: _User.reducer,
  filters: _Filters.reducer,
  router: _reactRouterRedux.routerReducer,
  map: _Map.reducer,
  scroll: _scrollReducer2.default,
  serverside: _ServerSide.reducer,
  utmCodes: _UTMCodes.reducer
});

exports.default = appReducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/reducers.js
// module id = 886
// module chunks = 0